import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=231be27a&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231be27a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231be27a')) {
      api.createRecord('231be27a', component.options)
    } else {
      api.reload('231be27a', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=231be27a&scoped=true&", function () {
      api.rerender('231be27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/comp/Voucher-Unit.vue"
export default component.exports